module.exports = __webpack_public_path__ + "static/media/azure.a976c85b.png";